var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.to)?_c('router-link',{attrs:{"to":_vm.to}},[_vm._v(" "+_vm._s(_vm.item.title)+" ")]):_c('a',{attrs:{"href":_vm.href,"target":"_blank"}},[_vm._v(" "+_vm._s(_vm.item.title)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }